import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import styled from "styled-components";

export const PinExtensionRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
`;

export const PinExtensionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 32rem;
`;
export const PinExtensionNote = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30rem;
  top: 5rem;
  align-items: center;
`;

export const PinExtensionImage = styled.img`
  width: 100%;
  margin-bottom: 8rem;
`;

export const PinExtensionPuzzleIcon = styled.img`
  width: 2.4rem;
`;

export const PinExtensionFooterText = styled(Paragraph)`
  color: ${vars.colors.white};
  margin-bottom: 1.2rem;
`;

export const PinExtensionStepText = styled(Paragraph)`
  color: ${vars.colors.sky};
`;
